import { Pipe, PipeTransform } from '@angular/core';
import { AnyObject } from '@mri/types';

@Pipe({
  name: 'isHasElement',
  standalone: true
})
export class IsHasElementPipe implements PipeTransform {

  transform(elementIdSet: Set<string>, element: AnyObject): unknown {
    return elementIdSet.has(element._id);
  }

}
